import { render, staticRenderFns } from "./FooterSaleBox.vue?vue&type=template&id=563047c4&scoped=true&"
import script from "./FooterSaleBox.vue?vue&type=script&lang=js&"
export * from "./FooterSaleBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563047c4",
  null
  
)

export default component.exports